import React, { useState, useEffect, useRef } from 'react'
import { Button, Form } from 'semantic-ui-react'
import useModal from 'hooks/useModal'
import * as R from 'ramda'

export default function AuthenticateModal({
  authenticationSettings,
  connectorProperties,
  loading,
  isAuthenticateSuccessful,
  onSubmit,
}) {
  const { Modal, open, close } = useModal()
  const [fields, setFields] = useState([])
  const hiddenSubmitButtonRef = useRef(null)

  function handleSubmit(event) {
    event.preventDefault()
    onSubmit(fields)
  }

  function handleOnChange(index, value) {
    setFields((fields) => R.assocPath([index, 'value'], value, fields))
  }

  function handleTriggerSubmit() {
    if (R.prop('current', hiddenSubmitButtonRef)) {
      hiddenSubmitButtonRef.current.click()
    }
  }

  useEffect(() => {
    if (authenticationSettings) {
      connectorProperties.forEach(function (connector) {
        connector.type = 'properties'
      })
      setFields([...connectorProperties, ...authenticationSettings])
    }
  }, [connectorProperties, authenticationSettings])

  useEffect(() => {
    if (isAuthenticateSuccessful) {
      close()
    }
  }, [close, isAuthenticateSuccessful])

  return (
    <>
      <Button primary onClick={open}>
        Authenticate
      </Button>
      <Modal size="small">
        <Modal.Header>Authenticate</Modal.Header>
        <Modal.Content>
          <Form onSubmit={handleSubmit}>
            {fields.map((field, index) => (
              <Form.Field key={field.name}>
                <label>{field.label}</label>
                <input
                  type="text"
                  name={field.name}
                  placeholder={field.placeholder}
                  onChange={(e) => handleOnChange(index, e.target.value)}
                  required
                />
              </Form.Field>
            ))}
            <input type="submit" hidden ref={hiddenSubmitButtonRef} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={close}>Cancel</Button>
          <Button primary onClick={handleTriggerSubmit} loading={loading} disabled={loading}>
            Authenticate
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/components/CyclrIntegrationAuthenticationSegment/AuthenticateModal.tsx